import * as React from 'react'
import { badgeVariants, type BadgeVariantProps } from './Badge.variants'
import { cn } from '../../utils/cn'

export type BadgeProps = BadgeVariantProps &
  React.HTMLAttributes<HTMLSpanElement> & {
    children: React.ReactNode
  }

export default function Badge({ variant, className, children, ...rest }: BadgeProps) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...rest}>
      {children}
    </span>
  )
}
